import { tlStore} from "../CorBase/CoreBase";

export function checkBoxToString(requiredRight: boolean): string {
	return requiredRight == true ? 'global.answerYes' :'global.answerNo';
}

